var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoluPurifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.958,
    cy: 105.958,
    r: 75,
    transform: "rotate(-132.412 105.958 105.958)",
    fill: "url(#paint0_angular_937_6465)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_6465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.766 107.31V74.0254C103.766 72.5122 104.993 71.2856 106.506 71.2856C108.019 71.2856 109.245 72.5122 109.245 74.0254V135.806C109.245 137.319 108.019 138.546 106.506 138.546C104.993 138.546 103.766 137.319 103.766 135.806V119.593",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0188 103.546C83.7056 103.546 83.7056 106.286 90.3924 106.286C97.0791 106.286 97.0792 103.546 103.766 103.546",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0188 83.2302C83.7056 83.2302 83.7056 85.97 90.3924 85.97C97.0791 85.97 97.0792 83.2302 103.766 83.2302",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0188 123.862C83.7056 123.862 83.7056 126.602 90.3924 126.602C97.0791 126.602 97.0792 123.862 103.766 123.862",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.9032,
    cy: 90.6157,
    r: 1.36986,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.9684,
    cy: 75.6135,
    r: 1.36986,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6067,
    cy: 111.93,
    r: 1.36986,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2806 119.205C84.7937 119.205 86.0203 117.978 86.0203 116.465C86.0203 114.952 84.7937 113.725 83.2806 113.725C81.7675 113.725 80.5409 114.952 80.5409 116.465C80.5409 117.978 81.7675 119.205 83.2806 119.205Z",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6225 99.351C95.1356 99.351 96.3623 98.1244 96.3623 96.6113C96.3623 95.0982 95.1356 93.8716 93.6225 93.8716C92.1094 93.8716 90.8828 95.0982 90.8828 96.6113C90.8828 98.1244 92.1094 99.351 93.6225 99.351Z",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.6807,
    cy: 133.643,
    r: 1.36986,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.928 101.192V98.3053C124.928 97.9833 125.287 97.7913 125.555 97.9701L134.963 104.252C135.436 104.568 135.436 105.264 134.963 105.58L125.555 111.862C125.287 112.041 124.928 111.849 124.928 111.527V109.035H109.246V101.192L124.928 101.192Z",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.928 80.0816V77.1947C124.928 76.8727 125.287 76.6808 125.555 76.8595L134.963 83.1416C135.436 83.4576 135.436 84.1531 134.963 84.4691L125.555 90.7512C125.287 90.9301 124.928 90.738 124.928 90.416V87.9243H109.246V80.0814L124.928 80.0816Z",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.928 122.303V119.416C124.928 119.094 125.287 118.902 125.555 119.081L134.963 125.363C135.436 125.679 135.436 126.374 134.963 126.69L125.555 132.972C125.287 133.151 124.928 132.959 124.928 132.637V130.146H109.246V122.303L124.928 122.303Z",
    stroke: "white",
    strokeWidth: 3.63992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.766,
    cy: 113.451,
    r: 1.36986,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_937_6465",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.958 105.958) rotate(109.771) scale(79.6983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FE5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C89E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_6465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(71.1685 69.9158)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoluPurifying);
export default __webpack_public_path__ + "static/media/SoluPurifying.601a506119eb647d7a3fbcf699118017.svg";
export { ForwardRef as ReactComponent };